import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/danielwong/facility-calcom/cal2/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
